/**
 * Время до показа §82 (change stage9-display-min-age): личная настройка
 * «сколько секунд строка должна прожить, прежде чем попасть на экран».
 *
 * `minAgeSec = null` — настройка не задана. Пока она не прочитана
 * (`loading`) или прочитать её не удалось (`unavailable`), отбор ведёт себя
 * как при «не задано», а ошибка называется на экране отдельной надписью.
 */
export type DisplayMinAgeState =
  | { status: "loading" }
  | { status: "ready"; minAgeSec: number | null }
  | { status: "unavailable" };

/** Настройка не задана: нейтральное значение для вызовов, которым она безразлична. */
export const DISPLAY_MIN_AGE_NOT_SET: DisplayMinAgeState = { status: "ready", minAgeSec: null };

/** Действующее время до показа в секундах, либо `null`, если оно не действует. */
export function activeDisplayMinAgeSec(state: DisplayMinAgeState): number | null {
  return state.status === "ready" ? state.minAgeSec : null;
}

export function displayMinAgeUnavailable(state: DisplayMinAgeState): boolean {
  return state.status === "unavailable";
}
